var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTxt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-753 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(753 489)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(721.639 489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M51.959,8.882h-.6V6a.417.417,0,0,0-.005-.054.478.478,0,0,0-.116-.315L46.455.167l0,0a.479.479,0,0,0-.1-.081L46.322.063a.508.508,0,0,0-.1-.04L46.2.014A.484.484,0,0,0,46.088,0H34.323a.975.975,0,0,0-.974.974V8.882h-.6a1.392,1.392,0,0,0-1.392,1.392v7.237A1.392,1.392,0,0,0,32.753,18.9h.6v4.954a.975.975,0,0,0,.974.974H50.389a.975.975,0,0,0,.974-.974V18.9h.6a1.392,1.392,0,0,0,1.392-1.392V10.274A1.391,1.391,0,0,0,51.959,8.882ZM34.323.974H45.6V5.956a.487.487,0,0,0,.487.487h4.3V8.882H34.323Zm4.8,9.218h1.888l.637,1.327c.215.442.378.8.55,1.208h.022c.172-.464.312-.788.5-1.208l.615-1.327H45.21L43.16,13.74l2.157,3.722h-1.9l-.658-1.316c-.27-.507-.443-.884-.648-1.305h-.022c-.151.421-.334.8-.561,1.305l-.6,1.316H39.05l2.1-3.678Zm-6.192,1.381V10.192h5.588v1.381H36.536v5.89h-1.65v-5.89ZM50.389,23.593H34.323V18.9H50.389v4.69Zm.916-12.021H49.321v5.89H47.67v-5.89H45.718V10.192h5.588v1.381Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.c03a95b5be5314b432aa7d13284bb7c1.svg";
export { ForwardRef as ReactComponent };